import { OverlayBoundary } from '../desktopApp/longread/editor/EditorOverlay/styles';
import React, { useMemo } from 'react';
import { GeneralEditorOverlay } from '../desktopApp/longread/editor/EditorOverlayNew/GeneralEditorOverlay';
import { VideoPlayer } from './VideoPlayer';
import CommentViewController from '../desktopApp/comments';
import useCommonProps from '../../hooks/useCommonProps';
export var NewVideoBlock = function (props) {
    var isFeed = useCommonProps().isFeed;
    var post = props.post, dragHandleProps = props.dragHandleProps, isEditable = props.isEditable;
    var editOverlay = (React.createElement(GeneralEditorOverlay, { isEditable: isEditable, post: post, withoutDrag: isFeed, dragHandleProps: dragHandleProps }));
    // const commentController = useMemo(() => {
    //   return (
    //     <CommentViewController postEntityId={post?.postId} />
    //   )
    // } , [post])
    return (React.createElement(OverlayBoundary, null,
        editOverlay,
        React.createElement(VideoPlayer, { link: (post === null || post === void 0 ? void 0 : post.text) || '', post: post })));
};
//# sourceMappingURL=NewVideoBlock.js.mapimport { OverlayBoundary } from '../desktopApp/longread/editor/EditorOverlay/styles';
import React, { useMemo } from 'react';
import { GeneralEditorOverlay } from '../desktopApp/longread/editor/EditorOverlayNew/GeneralEditorOverlay';
import { VideoPlayer } from './VideoPlayer';
import CommentViewController from '../desktopApp/comments';
import useCommonProps from '../../hooks/useCommonProps';
export var NewVideoBlock = function (props) {
    var isFeed = useCommonProps().isFeed;
    var post = props.post, dragHandleProps = props.dragHandleProps, isEditable = props.isEditable;
    var editOverlay = (React.createElement(GeneralEditorOverlay, { isEditable: isEditable, post: post, withoutDrag: isFeed, dragHandleProps: dragHandleProps }));
    // const commentController = useMemo(() => {
    //   return (
    //     <CommentViewController postEntityId={post?.postId} />
    //   )
    // } , [post])
    return (React.createElement(OverlayBoundary, null,
        editOverlay,
        React.createElement(VideoPlayer, { link: (post === null || post === void 0 ? void 0 : post.text) || '', post: post })));
};
//# sourceMappingURL=NewVideoBlock.js.map